import type { ReactNode } from "react";
import { useI18n } from "@/locales/i18n-provider";
import { cn } from "@/utils";
import type { DataTableDensity } from "./use-data-table";

type DataTableFrameProps = {
  children: ReactNode;
  className?: string;
  density?: DataTableDensity;
  footer?: ReactNode;
  isBusy?: boolean;
};

/** HRMS 的灰色外框、独立滚动区和外置页脚；骨架与数据共用。 */
export function DataTableFrame({ children, className, density = "default", footer, isBusy = false }: DataTableFrameProps) {
  const { t } = useI18n();

  return (
    <div className={cn("flex min-h-0 min-w-0 max-w-full flex-1 flex-col gap-3", className)} data-density={density} data-slot="data-table">
      <div className="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden rounded-xl bg-muted px-1 pb-1" data-slot="data-table-container">
        <section
          aria-busy={isBusy}
          aria-label={t("dataTable.scrollRegion")}
          className="data-table-scroll @container/table-scroll min-h-0 min-w-0 flex-1 overflow-auto overscroll-contain rounded-xl focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-ring"
          data-slot="data-table-scroll"
          // biome-ignore lint/a11y/noNoninteractiveTabindex: 键盘用户需要聚焦此区域后滚动表格。
          tabIndex={0}
        >
          {children}
        </section>
      </div>
      {footer}
    </div>
  );
}
